import React, { useState, useRef, useEffect } from "react";
import {
  Bell,
  User,
  LogOut,
  KeyRound,
  ChevronDown,
  Menu,
  Plus,
  Users,
  Briefcase,
  UserCheck,
  ExternalLink,
  CheckCircle2,
  Timer,
  X,
} from "lucide-react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import StatCard from "../components/ui/StatCard";
import { useNavigate } from "react-router-dom";

const Departments = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const departmentsDetails = [
    {
      id: 1,
      name: "إدارة التوقيع الإلكتروني",
      manager: "بيتر عزيز",
      employees: 3,
      projects: 1,
      status: "نشط",
      color: "blue",
      path: "/e-signature",
    },
    {
      id: 2,
      name: "إدارة دعم التعاملات الضريبية",
      manager: "دعاء سيد",
      employees: 1,
      projects: 1,
      status: "نشط",
      color: "green",
      path: "/SupportdSec1",
    },
    {
      id: 3,
      name: "إدارة التوعية والإرشاد",
      manager: "ميرفت عدلي",
      employees: 3,
      projects: 1,
      status: "قيد المراجعة",
      color: "orange",
      path: "/awareness",
    },
    {
      id: 4,
      name: "إدارة تطوير التعاملات",
      manager: "غاده أبو زيد",
      employees: 3,
      projects: 1,
      status: "قيد المراجعة",
      color: "blue",
      path: "/development",
    },
  ];

 useEffect(() => {
      document.title = " الإدارات - الإدارة العامة للعمليات والتوقيع الإلكتروني"; 
    }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex min-h-screen bg-[#F8F9FA] font-ibm" dir="rtl">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
      />

      <div
        className={`flex-1 transition-all duration-300 p-4 md:p-8 ${
          isSidebarOpen ? "lg:mr-64" : "lg:mr-20"
        }`}
      >
        {/* Header */}
          {/* Header */}
        <Header
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          title="الإدارات" 
        />

        {/* Hero Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6">
          <div className="text-right">
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#546E7A]">
              الإدارات
            </h2>
            <p className="text-gray-400 mt-1">
              نظرة عميقة على توزيع الموارد والمسؤوليات
            </p>
          </div>
          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-[#546E7A] hover:bg-[#263238] text-white px-8 py-3 rounded-2xl font-bold flex items-center gap-2 transition shadow-lg shadow-[#546e7a20] w-full md:w-auto justify-center active:scale-95"
          >
            <Plus size={20} /> إدارة جديدة
          </button>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          <StatCard
            title="إجمالي الموظفين"
            value="16"
            icon={<Users size={40} className="text-[#546E7A]" />}
            badge="محدث"
            badgeColor="text-blue-500 bg-blue-50"
          />
          <StatCard
            title="إدارات نشطة"
            value="4"
            icon={<CheckCircle2 size={40} className="text-[#546E7A]" />}
            badge="ممتاز"
            badgeColor="text-green-500 bg-green-50"
          />
          <StatCard
            title="مشاريع المراجعة"
            value="2"
            icon={<Timer size={40} className="text-[#546E7A]" />}
            badge="تنبيه"
            badgeColor="text-orange-500 bg-orange-50"
          />
        </div>

        {/* Departments Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {departmentsDetails.map((dept) => (
            <div
              key={dept.id}
              className="bg-white p-6 rounded-[2rem] border border-gray-100 shadow-sm hover:shadow-md transition-all relative overflow-hidden group"
            >
              <div
                className={`absolute top-0 right-0 w-2 h-full transition-all group-hover:w-3 ${
                  dept.color === "blue" ? "bg-blue-500" : 
                  dept.color === "green" ? "bg-green-500" : 
                  dept.color === "orange" ? "bg-orange-500" : "bg-gray-200"
                }`}
              ></div>

              <div className="flex justify-between items-start mb-6">
                <h3 className="font-bold text-[#263238] text-lg pr-2">
                  {dept.name}
                </h3>
                <button 
                  onClick={() => dept.path && navigate(dept.path)}
                  className="text-gray-300 hover:text-[#546E7A] transition-colors"
                >
                  <ExternalLink size={18} />
                </button>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-4 bg-gray-50/50 p-3 rounded-xl border border-gray-50">
                  <div className="bg-white p-2 rounded-lg shadow-sm text-[#546E7A]">
                    <UserCheck size={18} />
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] text-gray-400 font-medium">مدير الإدارة</p>
                    <p className="text-sm font-bold text-[#546E7A]">{dept.manager}</p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center gap-3 pr-2">
                    <div className="text-[#546E7A] bg-blue-50 p-2 rounded-full">
                      <Users size={16} />
                    </div>
                    <div className="text-right">
                      <p className="text-[10px] text-gray-400 uppercase tracking-wider">الموظفين</p>
                      <p className="text-sm font-extrabold">{dept.employees}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 pr-2">
                    <div className="text-[#546E7A] bg-purple-50 p-2 rounded-full">
                      <Briefcase size={16} />
                    </div>
                    <div className="text-right">
                      <p className="text-[10px] text-gray-400 uppercase tracking-wider">المشاريع</p>
                      <p className="text-sm font-extrabold">{dept.projects}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-4 border-t border-gray-50 flex justify-end">
                <button 
                  onClick={() => dept.path && navigate(dept.path)}
                  className={`text-[12px] font-bold flex items-center gap-1 transition-all hover:gap-2 ${
                    dept.path ? "text-[#546E7A] hover:underline" : "text-gray-300 cursor-not-allowed"
                  }`}
                >
                  {dept.path ? "شاشة الإدارة ←" : "قيد التطوير"}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* --- Modal: إضافة إدارة جديدة مع Floating Labels --- */}
        {isModalOpen && (
          <div className="fixed inset-0 z-[200] overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <div 
                className="fixed inset-0 bg-[#263238]/60 backdrop-blur-sm animate-in fade-in duration-300"
                onClick={() => setIsModalOpen(false)}
              ></div>

              <div className="relative bg-white w-full max-w-xl rounded-[2.5rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300 text-right" dir="rtl">
                
                <div className="p-8 border-b border-gray-50 flex justify-between items-center bg-[#F8F9FA]">
                  <div className="flex items-center gap-3">
                    <div className="bg-[#546E7A]/10 p-2 rounded-xl text-[#546E7A]">
                      <Plus size={24} />
                    </div>
                    <h3 className="text-2xl font-bold text-[#263238]">إضافة إدارة جديدة</h3>
                  </div>
                  <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                    <X size={24} className="text-gray-400" />
                  </button>
                </div>

                <form className="p-8 space-y-6" onSubmit={(e) => e.preventDefault()}>
                  {/* اسم الإدارة - Floating */}
                  <div className="relative">
                    <input 
                      type="text" 
                      id="dept_name"
                      placeholder=" " 
                      className="block px-5 pb-3 pt-6 w-full text-[#263238] bg-gray-50 rounded-2xl border border-gray-100 appearance-none focus:outline-none focus:bg-white focus:border-[#546E7A] focus:ring-4 focus:ring-[#546E7A]/5 peer transition-all"
                    />
                    <label 
                      htmlFor="dept_name"
                      className="absolute text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A] font-bold pointer-events-none"
                    >
                      اسم الإدارة
                    </label>
                  </div>

                  {/* مدير الإدارة - Floating */}
                  <div className="relative">
                    <input 
                      type="text" 
                      id="dept_manager"
                      placeholder=" " 
                      className="block px-5 pb-3 pt-6 w-full text-[#263238] bg-gray-50 rounded-2xl border border-gray-100 appearance-none focus:outline-none focus:bg-white focus:border-[#546E7A] focus:ring-4 focus:ring-[#546E7A]/5 peer transition-all"
                    />
                    <label 
                      htmlFor="dept_manager"
                      className="absolute text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A] font-bold pointer-events-none"
                    >
                      مدير الإدارة
                    </label>
                  </div>

                  <div className="grid grid-cols-2 gap-5">
                    {/* عدد الموظفين - Floating */}
                    <div className="relative">
                      <input 
                        type="number" 
                        id="emp_count"
                        placeholder=" " 
                        className="block px-5 pb-3 pt-6 w-full text-[#263238] bg-gray-50 rounded-2xl border border-gray-100 appearance-none focus:outline-none focus:bg-white focus:border-[#546E7A] peer transition-all"
                      />
                      <label 
                        htmlFor="emp_count"
                        className="absolute text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A] font-bold pointer-events-none"
                      >
                        عدد الموظفين
                      </label>
                    </div>

                    {/* لون التمييز - Floating Select */}
                    <div className="relative">
                      <select 
                        id="dept_color"
                        className="block px-5 pb-3 pt-6 w-full text-[#263238] bg-gray-50 rounded-2xl border border-gray-100 appearance-none focus:outline-none focus:bg-white focus:border-[#546E7A] peer transition-all cursor-pointer"
                      >
                        <option value="blue">أزرق</option>
                        <option value="green">أخضر</option>
                        <option value="orange">برتقالي</option>
                      </select>
                      <label 
                        htmlFor="dept_color"
                        className="absolute text-[#546E7A] duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-5 font-bold pointer-events-none"
                      >
                        لون التمييز
                      </label>
                    </div>
                  </div>

                  <div className="flex gap-4 pt-6">
                    <button 
                      type="submit"
                      className="flex-[2] bg-[#546E7A] hover:bg-[#263238] text-white py-4 rounded-2xl font-bold transition-all shadow-xl shadow-[#546e7a30] active:scale-[0.98]"
                    >
                      حفظ الإدارة
                    </button>
                    <button 
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 py-4 rounded-2xl font-bold transition-all active:scale-[0.98]"
                    >
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Departments;